// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1KWxm","log":"ModalInventoryLogs_log__j5gvB","date":"ModalInventoryLogs_date__17Y0E","userName":"ModalInventoryLogs_userName__13NKm"};